import { PlainButton, SkeletonShape } from '@customerio/pluma-components/react';
import clsx from 'clsx';
import { compact } from 'lodash-es';
import { GradientRing, gradientHoverTarget } from '@/components/feedback/gradient-ring';
import * as styles from './index.css';
import { HUMAN_SUPPORT_SUGGESTION } from './static-suggestions';

export { useSuggestions, type SuggestionState } from './hook';
export { MarqueeSuggestions } from './marquee';

interface SuggestionsProps {
  suggestions: Array<{ label: string; message: string }>;
  onSuggestionClick: (message: string, index: number) => void;
  shouldShowPlaceholder?: boolean;
  shouldIncludeHumanSupport?: boolean;
}

export function Suggestions({
  suggestions,
  onSuggestionClick,
  shouldIncludeHumanSupport = false,
  shouldShowPlaceholder = false,
}: SuggestionsProps) {
  const handleSuggestionClick = (message: string, index: number) => {
    onSuggestionClick(message, index);
  };

  if (suggestions.length === 0) {
    return shouldShowPlaceholder ? (
      <>
        <SkeletonShape style={{ width: 120, height: 29 }} />
        <SkeletonShape style={{ width: 130, height: 29 }} />
        <SkeletonShape style={{ width: 140, height: 29 }} />
        {shouldIncludeHumanSupport ? <SkeletonShape style={{ width: 80, height: 29 }} /> : null}
      </>
    ) : null;
  }

  return (
    <>
      {compact([...suggestions, shouldIncludeHumanSupport ? HUMAN_SUPPORT_SUGGESTION : null]).map(
        (suggestion, index) => (
          <GradientRing key={suggestion.label} radius={4}>
            <PlainButton
              className={clsx(styles.suggestionButton, gradientHoverTarget)}
              onClick={() => handleSuggestionClick(suggestion.message, index + 1)}
            >
              {suggestion.label}
            </PlainButton>
          </GradientRing>
        ),
      )}
    </>
  );
}
